







import * as Palette from '@/assets/palette'

export default {
  name: 'map-legend',

  data() {
    return {
      context: undefined,
      pxRatio: window.devicePixelRatio || 1,
      highlighted: false,
      layerLegends: {}
    }
  },

  computed: {
    layer() {
      return this.$store.state.persistent.layer
    },
    colorblind() {
      return this.$store.state.persistent.colorblind
    },
    roundedAltitude() {
      return this.$store.getters['persistent/roundedAltitude']
    },
    palette() {
      const palette = this.layerLegends[this.layer].palette
      return this.colorblind ? palette + '_CB' : palette
    },
    legendTxtA() {
      return this.layerLegends[this.layer].legendA
    },
    legendTxtB() {
      const txt = this.layerLegends[this.layer].legendB
      return txt === '_ALTI_' ? `${this.roundedAltitude}m` : txt
    },
    unitTxt() {
      const unit = this.layerLegends[this.layer].unit
      return unit === '_WIND_UNIT_' ? this.$convert.currentLabel : unit
    },
    windUnit() {
      return this.$store.state.persistent.windUnit
    },
    lang() {
      return this.$store.state.persistent.lang
    }
  },

  watch: {
    layer() {
      this.draw()
    },
    colorblind() {
      this.draw()
    },
    roundedAltitude() {
      this.draw()
    },
    lang() {
      this.layerLegends = this.updateLayerLegends()
      this.draw()
    },
    windUnit() {
      this.layerLegends = this.updateLayerLegends()
      this.draw()
    }
  },

  mounted() {
    this.layerLegends = this.updateLayerLegends()
    this.context = this.$refs.legend.getContext('2d')
    window.addEventListener('resize', this.draw)
    this.draw()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.draw)
  },

  methods: {
    toggleHighlight() {
      this.highlighted = !this.highlighted
      this.draw()
    },
    hideHighlight() {
      this.highlighted = false
      this.draw()
    },
    draw() {
      window.requestAnimationFrame(this._draw)
    },
    _draw() {
      const height = this.$refs.legend.clientHeight * this.pxRatio
      const width = this.$refs.legend.clientWidth * this.pxRatio

      this.$refs.legend.width = width
      this.$refs.legend.height = height

      const ctx = this.context
      ctx.clearRect(0, 0, width, height)

      const w = width
      const h = height

      ctx.clearRect(0, 0, w, h)

      const paddingTop = 55 * this.pxRatio
      const paddingBottom = 55 * this.pxRatio

      const freeHeight = h - paddingTop - paddingBottom

      const palette = Palette.getPalette(this.palette)

      const colorCount = palette.length
      // const colorWidth = 8
      let colorWidth = this.highlighted ? 24 : 8
      colorWidth *= this.pxRatio
      const colorHeight = Math.round(freeHeight / colorCount)
      const colorLeft = 0
      // const colorLeft = this.highlighted ? 1 : w - colorWidth
      const textLeft = colorWidth + (4 * this.pxRatio)

      ctx.font = `bold ${12 * this.pxRatio}px sans-serif`
      ctx.textBaseline = 'alphabetic'
      ctx.textAlign = 'start'
      const textColor = 'white'
      const textShadowBlur = 6
      const colorShadowBlur = 1

      ctx.shadowColor = 'black'
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 0

      let i = 0
      ctx.shadowBlur = colorShadowBlur
      let bottom = h - paddingBottom

      if (!this.highlighted) {
        ctx.fillStyle = `rgba(${palette[i][1]}, ${palette[i][2]}, ${palette[i][3]}, ${palette[i][4]})`
        ctx.fillRect(colorLeft, h, colorWidth, -paddingBottom)
      }

      for (i = 0; i < colorCount; i++) {
        ctx.fillStyle = `rgba(${palette[i][1]},${palette[i][2]}, ${palette[i][3]}, ${palette[i][4]})`
        ctx.fillRect(colorLeft, bottom, colorWidth, -colorHeight)
        bottom -= colorHeight
      }

      i = colorCount - 1
      if (!this.highlighted) {
        ctx.fillStyle = `rgba(${palette[i][1]}, ${palette[i][2]}, ${palette[i][3]}, ${palette[i][4]})`
        ctx.fillRect(colorLeft, 0, colorWidth, bottom)
      }

      ctx.shadowBlur = textShadowBlur
      ctx.fillStyle = textColor

      bottom = h - paddingBottom
      // ctx.fillText(this.layer, textLeft, bottom - 2 - 16)

      for (i = 0; i < colorCount; i++) {
        if (((i % 2) === 0)) {
          const text = (this.palette === 'PAL_WIND' || this.palette === 'PAL_WIND_CB') ? Math.round(this.$getwind(palette[i][0])) : palette[i][0]
          ctx.fillText(text, textLeft, bottom - (2 * this.pxRatio))
        }
        bottom -= colorHeight
      }

      ctx.font = `italic bold ${12 * this.pxRatio}px sans-serif`
      ctx.fillText(this.unitTxt, textLeft, bottom - (2 * this.pxRatio))

      ctx.font = `bold ${12 * this.pxRatio}px sans-serif`

      bottom -= 15 * this.pxRatio
      ctx.fillText(this.legendTxtB, textLeft, bottom)

      bottom -= 15 * this.pxRatio
      ctx.fillText(this.legendTxtA, textLeft, bottom)
    },
    updateLayerLegends() {
      return {
        pbltop: {
          palette: 'PAL_ALTI',
          unit: this.$pgettext('layer unit', 'm MSL'),
          legendA: this.$pgettext('layer legend A', 'Boundary Layer'),
          legendB: this.$pgettext('layer legend B', 'Ceiling')
        },
        pblh: {
          palette: 'PAL_ALTI',
          unit: this.$pgettext('layer unit', 'm AGL'),
          legendA: this.$pgettext('layer legend A', 'Boundary Layer'),
          legendB: this.$pgettext('layer legend B', 'Thickness')
        },
        ter: {
          palette: 'PAL_ALTI',
          unit: this.$pgettext('layer unit', 'm MSL'),
          legendA: this.$pgettext('layer legend A', 'Topography'),
          legendB: this.$pgettext('layer legend B', 'Model')
        },
        wstar: {
          palette: 'PAL_THERMIQUES',
          unit: this.$pgettext('layer unit', 'm/s'),
          legendA: this.$pgettext('layer legend A', 'Thermals'),
          legendB: this.$pgettext('layer legend B', 'Velocity')
        },
        bsratio: {
          palette: 'PAL_BSRATIO',
          unit: this.$pgettext('layer unit', 'dimensionless'),
          legendA: this.$pgettext('layer legend A', 'Thermals'),
          legendB: this.$pgettext('layer legend B', 'Shearing')
        },
        windsfc: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: this.$pgettext('layer legend B', 'Surface')
        },
        windblavg: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: this.$pgettext('layer legend B', 'Boundary Layer')
        },
        windbltop: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: this.$pgettext('layer legend B', 'Ceiling of BL')
        },
        windalti: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind'),
          legendB: '_ALTI_'
        },
        blwindshear: {
          palette: 'PAL_WIND',
          unit: '_WIND_UNIT_',
          legendA: this.$pgettext('layer legend A', 'Wind Shear'),
          legendB: this.$pgettext('layer legend B', 'Boundary Layer')
        },
        cfracl: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'Low altitude')
        },
        cfrach: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'High altitude')
        },
        cfracm: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'Medium altitude')
        },
        cfract: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: this.$pgettext('layer legend B', 'All altitudes')
        },
        cfracalti: {
          palette: 'PAL_CFRAC',
          unit: this.$pgettext('layer unit', '%'),
          legendA: this.$pgettext('layer legend A', 'Cloud cover'),
          legendB: '_ALTI_'
        },
        tc2: {
          palette: 'PAL_TEMP',
          unit: this.$pgettext('layer unit', '°C'),
          legendA: this.$pgettext('layer legend A', 'Temperature'),
          legendB: this.$pgettext('layer legend B', '2m AGL')
        },
        tempalti: {
          palette: 'PAL_TEMP',
          unit: this.$pgettext('layer unit', '°C'),
          legendA: this.$pgettext('layer legend A', 'Temperature'),
          legendB: '_ALTI_'
        },
        wblmaxmin: {
          palette: 'PAL_CONVERGENCE',
          unit: this.$pgettext('layer unit', 'm/s'),
          legendA: this.$pgettext('layer legend A', 'Vertical Motion'),
          legendB: this.$pgettext('layer legend B', 'Boundary Layer')
        },
        raintot: {
          palette: 'PAL_RAIN',
          unit: this.$pgettext('layer unit', 'mm/h'),
          legendA: this.$pgettext('layer legend A', 'Precipitations'),
          legendB: this.$pgettext('layer legend B', '1 hour')
        },
        slp: {
          palette: 'PAL_PRESS',
          unit: this.$pgettext('layer unit', 'hPa'),
          legendA: this.$pgettext('layer legend A', 'Pressure'),
          legendB: this.$pgettext('layer legend B', 'Mean Sea Level')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/map-legend.vue